import type { HttpPost } from '@/shared/infra/http'
import type { ArchiveChannel } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type ChannelDto, toChannel } from './channel-dto'

type ArchiveChannelResponseDto = {
  channel: ChannelDto
}

export class EdgeArchiveChannelRepository {
  constructor(private readonly http: HttpPost) {}

  execute: ArchiveChannel = async (params) => {
    try {
      const data = await this.http.post<unknown, ArchiveChannelResponseDto>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}/archive`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
        },
      })
      return { channel: toChannel(data.channel) }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
